export default {
  translation: {
    'Welcome to React': 'Welcome to React and react-i18next',
  },
};
